
      import API from "!../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.69.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.69.1/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.69.1/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.69.1/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.69.1/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.69.1/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.69.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[10].use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.69.1/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[10].use[2]!../../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.32.12_webpack@5.69.1/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[10].use[3]!./expandable-text-section.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.69.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[10].use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.3_webpack@5.69.1/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[10].use[2]!../../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.32.12_webpack@5.69.1/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[10].use[3]!./expandable-text-section.scss";
       export default content && content.locals ? content.locals : undefined;
